import { Chip, List, ListSubheader, Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Link } from 'shared/types';
import { GeoEventLinkItem } from './GeoEventLinkItem';

type GeoEventLinksProps = {
  links: Link[];
  internal?: boolean;
  emptyMessage?: string;
};

export const GeoEventLinks = (props: GeoEventLinksProps): JSX.Element => {
  const { links, internal, emptyMessage } = props;
  const { t } = useTranslation();

  return (
    <List
      subheader={
        <ListSubheader variant="watchduty-section-header">
          <Stack direction="row" spacing={1} alignItems="center">
            <Typography variant="h3">
              {t('geoEvent.structuredInfo.links')}
            </Typography>
            {internal && (
              <Chip
                label={t('internalChip.label')}
                variant="watchduty"
                color="error"
              />
            )}
          </Stack>
        </ListSubheader>
      }
    >
      {links.map((link) => (
        <GeoEventLinkItem key={`${link.label}-${link.value}`} link={link} />
      ))}
      {links.length === 0 && emptyMessage && (
        <Typography component="li" color="textSecondary" sx={{ p: 2 }}>
          {emptyMessage}
        </Typography>
      )}
    </List>
  );
};
